import { z } from 'zod';

import { cuidLike } from '../zod-common';

export const EXPORT_TYPES = ['DRAFT', 'OFFICIAL'] as const;
export type ExportTypeValue = (typeof EXPORT_TYPES)[number];

export const generateQuotePdfSchema = z.object({
  quoteId: cuidLike,
});
export type GenerateQuotePdfInput = z.infer<typeof generateQuotePdfSchema>;

export const generateConsolidatedQuotePdfSchema = z.object({
  selectionId: cuidLike,
});
export type GenerateConsolidatedQuotePdfInput = z.infer<typeof generateConsolidatedQuotePdfSchema>;

export const generateProjectCsvSchema = z.object({
  projectId: cuidLike,
});
export type GenerateProjectCsvInput = z.infer<typeof generateProjectCsvSchema>;

export const generateBidsCsvSchema = z.object({
  bidderId: cuidLike.optional(),
});
export type GenerateBidsCsvInput = z.infer<typeof generateBidsCsvSchema>;

export const exportCsvTypeSchema = z.enum(['project', 'bids']);
export type ExportCsvType = z.infer<typeof exportCsvTypeSchema>;

export const exportCsvRequestSchema = z.object({
  type: exportCsvTypeSchema,
  projectId: cuidLike.optional(),
  bidderId: cuidLike.optional(),
});
export type ExportCsvRequest = z.infer<typeof exportCsvRequestSchema>;
